import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface ApiError {
  message?: string;
  fields?: string[] | Record<string, string>;
}

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
  constructor(private matSnackBar: MatSnackBar) {}

  showApiError(
    error: any,
    defaultMsg: string,
    options?: any[],
    getDisplayName?: (fieldName: string, options: any[]) => string | undefined,
    isDataSplit: boolean = false
  ): void {
    const message = error?.error?.message;

    if (!message) {
      this.matSnackBar.open(defaultMsg, 'x');
      return;
    }

    const errorFields = error?.error?.fields;

    const fieldKey = Array.isArray(errorFields) ? errorFields[0] : Object.keys(errorFields || {})[0];
    let fieldName = fieldKey;
    if (isDataSplit) {
      fieldName = fieldKey?.split('.')?.at(-1) ?? fieldKey;
    }
    const displayName = options?.length && getDisplayName ? getDisplayName(fieldName, options) : fieldName;

    this.matSnackBar.open(displayName ? `${displayName} - ${message}` : message, 'x');
  }
}
